import { useMemo } from 'react';
import { AttachmentsViewer } from '@/components/common/AttachmentsViewer';
import { taskAttachmentsToPreviewable } from '@/utils/attachmentDownload';
import { Task } from '../../../../types';

interface TaskAttachmentsProps {
  task: Task;
  shareToken?: string;
}

export const TaskAttachments = ({ task, shareToken }: TaskAttachmentsProps) => {
  const previewableAttachments = useMemo(
    () => taskAttachmentsToPreviewable(task.attachments || [], shareToken),
    [task.attachments, shareToken]
  );

  return <AttachmentsViewer attachments={previewableAttachments} />;
};
